<template>
    <div class="parentMarket">
        <powerFutures>
        </powerFutures>   
        
        <gasFutures>
        </gasFutures>  
        
        <foreignEx>
        </foreignEx>

</div>
</template>
<script>
    import Vue from "vue";
    import powerFutures from '@/views/markets/marketSummaryFuture/PowerFutures';
    import gasFutures from '@/views/markets/marketSummaryFuture/GasFutures';
    import foreignEx from '@/views/markets/marketSummaryFuture/ForeignExchangeIndices';

    export default Vue.extend({
        components: {

            powerFutures,
            gasFutures,
            foreignEx
        },
        data() {
            return {
               
            };
        }
    });
</script>
<style>
    .parentMarket{
        display: flex;
    }
</style>